import React from 'react';
import { FormattedMessage } from 'react-intl';

import { SwitchBox } from '../../../molecules/switch-box';
import { HelpButton } from '../../../atoms/help-button';

export const SettingsSpBatteryDischargePrevent = () => {
  return (
    <>
      <SwitchBox
        title={
          <>
            <FormattedMessage
              id="settings.spot.battery.stop_discharge_low_price"
              defaultMessage="Zákaz vybíjení baterie při nízké ceně"
            />
            <HelpButton
              variant="dialog"
              title={
                <FormattedMessage
                  id="settings.spot.battery.stop_discharge_low_price"
                  defaultMessage="Zákaz vybíjení baterie při nízké ceně"
                />
              }
              content={
                <FormattedMessage
                  id="settings.spot.battery.stop_discharge_low_price.help"
                  defaultMessage="Pokud zvolíte tuto možnost, tak při nízké ceně spotu se nebude využívat energie z baterie. Systém nebude baterii vybíjet ani do spotřeby objektu. Ta se využije při vyšších cenách (střední a vysoká cena)."
                />
              }
            />
          </>
        }
        switchVariableId="SP_BATTERY_STOP_DISCHARGE_LOW_PRICE"
        subtitle={
          <FormattedMessage
            id="settings.spot.battery.stop_discharge_low_price.subtitle"
            defaultMessage="Řízení uschová energii na střední a vysokou cenu energie"
          />
        }
        visibility={{
          variableIds: [
            { variableId: 'SP_BATTERY_STOP_DISCHARGE_AUTO', reversed: true },
            'SP_INSTALL',
            'PV_BATTERY',
            'PV_BATTERY_CONTROL',
          ],
        }}
        fullWidth
      />
      <SwitchBox
        title={
          <>
            <FormattedMessage
              id="settings.spot.battery.stop_discharge_high_price"
              defaultMessage="Zákaz vybíjení baterie při nízké a střední ceně"
            />
            <HelpButton
              variant="dialog"
              title={
                <FormattedMessage
                  id="settings.spot.battery.stop_discharge_high_price"
                  defaultMessage="Zákaz vybíjení baterie při nízké a střední ceně"
                />
              }
              content={
                <FormattedMessage
                  id="settings.spot.battery.stop_discharge_high_price.help"
                  defaultMessage="Pokud zvolíte tuto možnost, tak při nízké a střední ceně spotu se nebude využívat energie z baterie. Systém nebude baterii vybíjet ani do spotřeby objektu. Ta se využije při vyšších cenách."
                />
              }
            />
          </>
        }
        switchVariableId="SP_BATTERY_STOP_DISCHARGE_MIDDLE_PRICE"
        subtitle={
          <FormattedMessage
            id="settings.spot.battery.stop_discharge_middle_price.subtitle"
            defaultMessage="Řízení uschová energii na vysokou cenu energie"
          />
        }
        visibility={{
          variableIds: [
            { variableId: 'SP_BATTERY_STOP_DISCHARGE_AUTO', reversed: true },
            'SP_INSTALL',
            'PV_BATTERY',
            'PV_BATTERY_CONTROL',
          ],
        }}
        fullWidth
      />
    </>
  );
};
